import React from 'react';
import PropTypes from 'prop-types';

export function DeleteConfrimationModal({ show, onClose, handleDeleteEvent, model,label }) {
    const handleConfirmDelete = () => {
        if (model.title) {
            handleDeleteEvent(model);
            onClose();
        }
    };

    if (!show) {
        return null;
    }
    return (
        <div className="admin-modal-overlay">
            <div className="admin-modal">
                <h2 className="admin-modal-heading">
                    Are you sure you want to delete this {(label == undefined || label == null) ? "record" : label}?
                </h2>
                <div className="admin-modal-row full">
                    <div className="admin-modal-cell">{model.title}</div>
                </div>
                <div className="admin-modal-button-wrap">
                    <button className="admin-modal-button" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        className="admin-form-button power red"
                        onClick={handleConfirmDelete}

                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
}

DeleteConfrimationModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    handleDeleteEvent: PropTypes.func.isRequired,
    model: PropTypes.object,
    label: PropTypes.string
};